import React, { useContext } from 'react';

type HeaderContextProps = {
  logout: () => Promise<void>;
  isPasswordAuth?: boolean;
};

const defaultContext = {
  logout: async () => {},
  isPasswordAuth: false
};

export const HeaderContext =
  React.createContext<HeaderContextProps>(defaultContext);

export const useHeaderContext = () => useContext(HeaderContext);
